import { Loader2, Inbox, AlertTriangle, RefreshCw } from "lucide-react";

export function Spinner({ label = "Loading" }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-[#71717A]" data-testid="loading-state">
      <Loader2 className="animate-spin text-[#E8552A]" size={28} />
      <span className="mono-label mt-3">{label}…</span>
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", sub, icon: Icon = Inbox, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
      <Icon className="text-[#3f3f46]" size={34} />
      <p className="font-display text-lg mt-4 text-[#A1A1AA]">{title}</p>
      {sub && <p className="text-sm text-[#71717A] mt-1 max-w-sm">{sub}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ message = "Something went wrong", onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="error-state">
      <AlertTriangle className="text-[#E8552A]" size={30} />
      <p className="text-[#A1A1AA] mt-3 text-sm max-w-sm">{message}</p>
      {onRetry && (
        <button data-testid="retry-btn" onClick={onRetry} className="mt-4 flex items-center gap-2 mono-label text-[#E8552A] border border-[#E8552A]/40 rounded-full px-4 py-2 hover:bg-[#E8552A]/10">
          <RefreshCw size={14} /> RETRY
        </button>
      )}
    </div>
  );
}

const STATUS_STYLES = {
  published: "text-[#10B981] border-[#10B981]/40 bg-[#10B981]/10",
  approved: "text-[#10B981] border-[#10B981]/40 bg-[#10B981]/10",
  Published: "text-[#10B981] border-[#10B981]/40 bg-[#10B981]/10",
  live: "text-[#10B981] border-[#10B981]/40 bg-[#10B981]/10",
  processing: "text-[#FF9F1C] border-[#FF9F1C]/40 bg-[#FF9F1C]/10",
  Processing: "text-[#FF9F1C] border-[#FF9F1C]/40 bg-[#FF9F1C]/10",
  Uploading: "text-[#FF9F1C] border-[#FF9F1C]/40 bg-[#FF9F1C]/10",
  Preparing: "text-[#FF9F1C] border-[#FF9F1C]/40 bg-[#FF9F1C]/10",
  submitted: "text-[#E8552A] border-[#E8552A]/40 bg-[#E8552A]/10",
  review: "text-[#E8552A] border-[#E8552A]/40 bg-[#E8552A]/10",
  requested: "text-[#E8552A] border-[#E8552A]/40 bg-[#E8552A]/10",
  pending: "text-[#FF9F1C] border-[#FF9F1C]/40 bg-[#FF9F1C]/10",
  changes: "text-[#FF9F1C] border-[#FF9F1C]/40 bg-[#FF9F1C]/10",
  draft: "text-[#A1A1AA] border-[#27272A] bg-[#1A1A22]",
  Waiting: "text-[#A1A1AA] border-[#27272A] bg-[#1A1A22]",
  rejected: "text-[#ef4444] border-[#ef4444]/40 bg-[#ef4444]/10",
  Failed: "text-[#ef4444] border-[#ef4444]/40 bg-[#ef4444]/10",
  suspended: "text-[#ef4444] border-[#ef4444]/40 bg-[#ef4444]/10",
  confirmed: "text-[#10B981] border-[#10B981]/40 bg-[#10B981]/10",
};

export function StatusBadge({ status, testid }) {
  const cls = STATUS_STYLES[status] || "text-[#A1A1AA] border-[#27272A] bg-[#1A1A22]";
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[0.65rem] font-mono uppercase tracking-wider ${cls}`}>
      {String(status || "—").replace(/_/g, " ")}
    </span>
  );
}

export function formatViews(n) {
  if (!n) return "0";
  if (n >= 1e6) return (n / 1e6).toFixed(1) + "M";
  if (n >= 1e3) return (n / 1e3).toFixed(1) + "K";
  return String(n);
}
